import { UI } from 'common';
import PropTypes from 'prop-types';
import React from 'react';

const { Link } = UI;

const FeesPopoverContent = ({ onUpgradeClick }) => (
	<div className="fees-accordion-header-popover">
		<p>
			You are subject to fees based on your subscription plan. Upgrade your plan
			to reduce or remove fees.
		</p>
		<Link
			onClick={() =>
				onUpgradeClick({
					eventTriggerOrigin: 'FeeDetails',
					upgradePrompt: 'upgradePromptReturnLabelHistory',
					triggerFeature: 'FeeDetails',
				})
			}
		>
			Compare plan fees
		</Link>
	</div>
);

FeesPopoverContent.propTypes = {
	onUpgradeClick: PropTypes.func.isRequired,
};

export default FeesPopoverContent;
